import React from 'react';
import { useThemeColors } from '../../hooks/useTheme';
import './Education.scss';

const education = [
  {
    id: 1,
    degree: "Master of Computer Applications (MCA)",
    institution: "Indira Gandhi National Open University (IGNOU), Delhi – Distance Education",
    year: "2025 – Present",
    description: "Currently pursuing postgraduate degree in Computer Applications"
  },
  {
    id: 2,
    degree: "Bachelor of Engineering (B.E.) – Mechanical Engineering",
    institution: "Paaval Engineering College, Namakkal, Tamil Nadu",
    year: "2015 – 2019",
    description: "Graduated with 78.0% aggregate score"
  },
  {
    id: 3,
    degree: "Specialized Training & Certifications",
    institution: "",
    year: "2019 – Present",
    description: [
      ".NET, SQL, Angular, Cybersecurity certifications",
      "React, AWS Cloud Practitioner",
      "DevOps fundamentals and best practices"
    ]
  }
];

const Education: React.FC = () => {
  const colors = useThemeColors();

  return (
    <section 
          id="education" 
          className="education" 
          style={{ 
            '--background': colors.background,
            '--surface': colors.surface,
            '--surface1': colors.surface1,
            '--primary': colors.primary,
            '--text': colors.text,
            '--accent': colors.accent,
            '--border': colors.border,
          } as React.CSSProperties}
        >
      <div className="education__container">
        <h2 className="education__title">Education</h2>
        
        <div className="education__timeline">
          {education.map(item => (
            <div 
              key={item.id} 
              className="education__item"
              style={{
                backgroundColor: colors.surface,
                border: `1px solid ${colors.border}`
              }}
            >
              <div className="education__year">{item.year}</div>
              <div className="education__content">
                <h3 className="education__degree">{item.degree}</h3>
                {item.institution && (
                  <h4 className="education__institution">{item.institution}</h4>
                )}
                {Array.isArray(item.description) ? (
                  <ul className="education__description-list">
                    {item.description.map((point, index) => (
                      <li key={index} className="education__description-point">
                        {point}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="education__description">{item.description}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;